import { object, number } from 'yup';
import { FinancialGoalType } from '../../context/SetGoalProvider';

export const LARGE_PURCHASE_GOAL_LABEL = "I'm allocating this money for a future purchase goal";

export const EXPENSE_GOAL_LABEL = 'I want to add this as an additional expense in my budget';

export interface FormValues {
  goalType: FinancialGoalType;
}

export const validation = object({
  goalType: number().required('Please, choose an option'),
});
